export class SessionFilterStorage {
  /**
   * Session storage that is configured to save filter object
   */
  constructor({
    featureName = '',
    filterEntityOptions = {},
    sessionStore,
    resourceId,
    entryId,
  } = {}) {
    if (!sessionStore) {
      throw new Error('No session store is provided');
    }
    this.featureName = featureName;

    if (resourceId) {
      this.resourceId = resourceId;
    } else {
      this.resourceId = this.getSessionStorageId({
        featureName,
        entityName: filterEntityOptions.entitySchema.name,
      }).resourceId;
    }

    if (entryId) {
      this.entryId = entryId;
    } else {
      this.entryId = this.getSessionStorageId({
        featureName,
        entityName: filterEntityOptions.entitySchema.name,
      }).entryId;
    }

    if (!sessionStore.definitions[this.resourceId]) {
      sessionStore.defineResource(this.resourceId);
    }

    this.storage = sessionStore.definitions[this.resourceId];
  }

  getSessionStorageId() {
    throw new Error('Not implemented');
  }

  save() {
    throw new Error('Not implemented');
  }

  get() {
    throw new Error('Not implemented');
  }

  clean() {
    return this.storage.destroy(this.entryId);
  }
}
